import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class UtilService {
    constructor(private messageService: NzMessageService) {}

    /**
     * @desc 设置对象的checked,indeterminate属性
     * @param obj - 被设置的对象
     * @param allChecked - 对象中数组是否全选
     * @param noChecked - 对象中数组是否全不选
     */
    updateChecked(obj, allChecked, noChecked): void {
        if (allChecked) {
            obj.checked = true;
            obj.indeterminate = false;
        } else if (noChecked) {
            obj.checked = false;
            obj.indeterminate = false;
        } else {
            // 有一部分选择
            obj.checked = false;
            obj.indeterminate = true;
        }
    }

    /**
     * @desc 更新对象父级选中状态
     * @param section - 父级对象
     * @param childKey - 孩子key
     */
    updateParentCheckbox(section, childKey): void {
        if (!section) {
            return;
        }
        let allChildrenChecked = true;
        let noChildChecked = true;
        for (const child of section[childKey]) {
            if (!child.checked || child.indeterminate) {
                allChildrenChecked = false;
            }
            if (child.checked) {
                noChildChecked = false;
            }
        }
        this.updateChecked(section, allChildrenChecked, noChildChecked);
    }

    // 把视图滚动到可视区域
    scrollIntoView(selectors): void {
        setTimeout(() => {
            const el = document.querySelector(selectors);
            el.scrollIntoView();
        }, 100);
    }

    /**
     * 判断是否为图片类型文件
     */
    isImgFile(fileName): boolean {
        if (!fileName) {
            return false;
        }
        // 支持预览类型后缀
        const imgTypeArr = ['.gif', '.jpg', '.jpeg', '.png'];
        const typeIndex = imgTypeArr.findIndex((element) => fileName.endsWith(element));
        return typeIndex !== -1;
    }
}
